import React from 'react';

export default function PageLayout({ title, description, actions, children }) {
  return (
    <div className="page-shell">
      <div className="page-inner">
        {/* ── Page Header ── */}
        <header className="page-header">
          <div>
            <h1 className="page-title">{title}</h1>
            {description && <p className="page-subtitle">{description}</p>}
          </div>
          {actions && <div className="page-actions">{actions}</div>}
        </header>

        {/* ── Page Content ── */}
        <main className="page-content">{children}</main>
      </div>
    </div>
  );
}
